import Stack from '@mui/material/Stack'
import { useAuthStore } from 'auth/AuthStore'
import AuthCardWrapper from 'auth/shared/AuthCardWrapper'
import { observer } from 'mobx-react-lite'
import useStore from 'reusable/mobx-store-utils'
import CenterFullScreen from 'reusable/mui/utilities/CenterFullScreen'
import AuthResetPasswordStore from './AuthResetPasswordStore'
import useInitialMount from 'reusable/hooks/useInitialMount'
import Typography from '@mui/material/Typography'
import ButtonWithProgress from 'reusable/mui/progress-button/ButtonWithProgress'
import TextFieldPassword from 'reusable/mui/text-field-password/TextFieldPassword'
import onEnterProp from 'reusable/utils/on-enter-prop'

export default observer(function AuthResetPassword() {
   const authStore = useAuthStore()
   const authResetPasswordStore = useStore(() => new AuthResetPasswordStore({ authStore }))

   useInitialMount(async () => {
      await authResetPasswordStore.fetchUser()
   })

   return <CenterFullScreen>
      <AuthCardWrapper title="Reset password">
         <Stack spacing={3}>
            <Typography sx={{ textAlign: 'center' }}>
               {authStore.fields.email}
            </Typography>
            {authResetPasswordStore.formHandler.password.bindInput(ip =>
               <TextFieldPassword
                  fullWidth
                  label="Password"
                  {...onEnterProp(authResetPasswordStore.resetPassword)}
                  {...ip}
               />)}
            {authResetPasswordStore.formHandler.passwordConfirm.bindInput(ip =>
               <TextFieldPassword
                  fullWidth
                  label="Confirm Password"
                  skipValidation
                  {...onEnterProp(authResetPasswordStore.resetPassword)}
                  {...ip}
               />)}
            <ButtonWithProgress
               loading={authResetPasswordStore.loader.isLoading}
               disabled={!authResetPasswordStore.user?.email}
               variant="contained"
               onClick={authResetPasswordStore.resetPassword}>
               Reset password
            </ButtonWithProgress>
         </Stack>
      </AuthCardWrapper>
   </CenterFullScreen>
})
